const EN = {
    title: 'Devices',
    table: {
        title: 'Devices',
        columns: {
            id: 'Device id',
            browser: 'Browser',
            vendor: 'Vendor',
            model: 'Model',
            os: 'Operating system',
            date: 'Date',
            status: 'Status',
            actions: 'Actions',
        },
        status: {
            0: 'Active',
            1: 'Inactive',
            title: 'Status'
        },
    }
};

export default EN;
